import React, { useEffect, useRef, memo } from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * SendFoxEmbed - Optimized for script persistence and DOM isolation.
 * Wrapped in React.memo to prevent re-render cycles from interrupting script execution.
 */
const SendFoxEmbed = memo(() => {
  const containerRef = useRef(null);
  const { t } = useLanguage();
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Prevent duplicate script injection if the component remounts quickly
    if (scriptLoaded.current) return;

    const script = document.createElement('script');
    script.src = 'https://cdn.sendfox.com/js/embed.js';
    script.dataset.form = 'mp9ggq';
    script.dataset.api = 'https://sendfox.com';
    script.async = true;

    if (containerRef.current) {
      containerRef.current.appendChild(script);
      scriptLoaded.current = true;
    }

    // IMPORTANT: Cleanup is omitted per instructions to ensure 
    // network requests (POST) are not interrupted by DOM removal.
  }, []);

  return (
    <div className="w-full min-h-[350px] flex flex-col items-center justify-center p-0">
      <div 
        ref={containerRef} 
        className="sendfox-form-container w-full"
        /* 
           This div acts as a static portal for the SendFox script. 
           React will not touch its children after the initial render.
        */
      >
        {/* Loading fallback displayed until SendFox injects the iframe/form */}
        <div className="flex flex-col items-center gap-3 py-12">
          <p className="text-brand-gold/50 text-[10px] tracking-ultra-wide animate-pulse font-sans uppercase">
            {t.loadingForm}
          </p>
        </div>
      </div>
    </div>
  );
});

SendFoxEmbed.displayName = 'SendFoxEmbed';

export default SendFoxEmbed;